import { Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Paper } from '@mui/material';
import { t } from 'i18next'

type BillingQuotesItemsTableProps = {
    deals: any
}

function BillingQuotesItemsTable({ deals }: BillingQuotesItemsTableProps) {

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {["billing:quotes_name", "billing:invoices_date", "billing:quotes_link"].map((title) => (
                            <TableCell align="center">
                                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                    {t(title)}
                                </Typography>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {deals.map((row: any) => (
                        <TableRow
                            key={row.properties.hs_object_id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell align="center" component="th" scope="row">
                                {row.properties.titre_du_devis}
                            </TableCell>
                            <TableCell align="center">{(new Date(row.properties.createdate)).toLocaleDateString()}</TableCell>
                            <TableCell align="center">
                                {
                                    row?.properties?.lien_du_devis && <a href={row.properties.lien_du_devis} target='_blank' rel="noreferrer">
                                        {t("billing:quotes_view_quote")}
                                    </a>
                                }

                            </TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default BillingQuotesItemsTable;
